import { render, staticRenderFns } from "./IconFavorite.vue?vue&type=template&id=7bc4915e&scoped=true"
import script from "./IconFavorite.vue?vue&type=script&lang=js"
export * from "./IconFavorite.vue?vue&type=script&lang=js"
import style0 from "./IconFavorite.vue?vue&type=style&index=0&id=7bc4915e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc4915e",
  null
  
)

export default component.exports